import { BASE_Action } from "../../Core/Redux/BaseAction";

export const SET_MENU = 'SET_MENU';
 
export const MENU_OPEN = '@customization/MENU_OPEN';
export const MENU_TYPE = '@customization/MENU_TYPE';
export const THEME_LOCALE = '@customization/THEME_LOCALE';
export const THEME_RTL = '@customization/THEME_RTL';
export const SET_FONT_FAMILY = '@customization/SET_FONT_FAMILY';
export const SET_BORDER_RADIUS = '@customization/SET_BORDER_RADIUS';
export const SET_CUSTOMISE_SIDEBAR_OPEN = '@customization/SET_CUSTOMISE_SIDEBAR_OPEN';
export const SET_SHOW_BREADCRUMB = '@customization/SET_SHOW_BREADCRUMB';
 

export type BackboneActionTypes =
    | BASE_Action<typeof MENU_OPEN, string>
    | BASE_Action<typeof MENU_TYPE, string>
    | BASE_Action<typeof THEME_LOCALE, string>
    | BASE_Action<typeof THEME_RTL, boolean>
    | BASE_Action<typeof SET_FONT_FAMILY, string>
    | BASE_Action<typeof SET_BORDER_RADIUS, number>
    | BASE_Action<typeof SET_MENU, boolean>
    | BASE_Action<typeof SET_CUSTOMISE_SIDEBAR_OPEN, boolean>
    | BASE_Action<typeof SET_SHOW_BREADCRUMB, boolean>;